'use client'

import React from 'react'
import { Heading } from '@/components/ui/heading'
import { ShardGrid } from '@/components/ShardGrid'
import { Container } from '@/components/Container'
import { CMSLink } from '@/components/Link'
import { CalloutWithShardsBlock } from '@/payload-types'
import { cn } from '@/utilities/ui'
import { Eyebrow } from '@/components/Eyebrow'
import RichText from '@/components/RichText'

export function CalloutWithShardsClient({
  backgroundColor,
  eyebrow,
  heading,
  description,
  links,
  shardSide,
  verticalSpace = 'normal',
}: CalloutWithShardsBlock) {
  const darkText = backgroundColor === 'rock-1' || backgroundColor === 'paper-1'
  const isTall = verticalSpace === 'tall'
  return (
    <Container
      tag="section"
      bgClassName={cn(
        backgroundColor === 'olive-2' && 'bg-olive-2',
        backgroundColor === 'paper-1' && 'bg-paper-1',
        backgroundColor === 'rock-1' && 'bg-rock-1',
      )}
      className="py-[50px] lg:py-0 overflow-hidden"
    >
      <div
        className={cn(
          'flex flex-col gap-x-[40px] lg:gap-x-[100px]',
          shardSide === 'right' ? 'lg:flex-row' : 'lg:flex-row-reverse',
        )}
      >
        <div
          className={cn(
            'lg:w-[600px] flex flex-col gap-[30px] lg:justify-center',
            isTall ? 'lg:py-[150px]' : 'lg:py-[80px]',
          )}
        >
          {eyebrow && eyebrow.label && (
            <Eyebrow
              label={eyebrow.label}
              color={eyebrow.color}
              variant={darkText ? 'dark' : 'light'}
            />
          )}
          <Heading size="h2" className={cn(darkText ? 'text-dark' : 'text-highlighter')}>
            {heading}
          </Heading>
          <RichText
            className={cn('prose', darkText ? 'prose-dark' : 'prose-light')}
            data={description}
          />
          <div className="flex flex-col md:flex-row gap-y-[10px] md:gap-x-[30px]">
            {links?.map((link, index) => <CMSLink key={index} {...link.link} />)}
          </div>
        </div>
        <div className={cn('px-[10px] lg:px-0 flex-1', isTall ? 'lg:py-[50px]' : 'lg:py-[30px]')}>
          <div className="h-[200px] lg:h-full">
            <ShardGrid minGapSize={50} />
          </div>
        </div>
      </div>
    </Container>
  )
}
